import DOMPurify from "dompurify";
const WelcomeHeading = ({ content, setStateName }) => {
  return (
    <section className=" brr-none border-0 mb-0">
      <div className="container-custom">
        ,
        <div className="row align-items-center flex-custom-col-reverse">
          <div className="col-md-6">
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(content?.estimate_heading || ""),
              }}
            />
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  content?.estimate_heading_below || "",
                ),
              }}
            />

            <div className="button-group">
              <a
                className="white_btn"
                onClick={() => setStateName("component_catalog")}
              >
                Add to Estimate
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 8V16"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8 12H16"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="col-md-6 text-md-end pb-5 ">
            <img
              src={content?.estimate_media_url}
              alt="estimate_media_url"
              className="w-50 "
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeHeading;
